import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FormatStrikethroughSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FormatStrikethroughSVG;
